import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities'
import PaginatedList from '@theme/paginated-list'
import CardBuy from '@theme/card-buy'

export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback()

    this.cardBuy = new CardBuy(this)

    // Re-init when new products are appended/replaced
    this._observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          this.cardBuy.init(this) // will only mark fresh nodes thanks to data-listener
          break
        }
      }
    })
    this._observer.observe(this, { childList: true, subtree: true })

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange)
    this.setAttribute('initialized', '')
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange)
    this._observer?.disconnect()
  }

  // Whenever your list/grid re-renders (pagination, filtering, etc.),
  // call init again so newly-added buttons get wired.
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs
    if (!grid) return

    await startViewTransition(() => this.#setLayout(value), ['product-grid'])

    // Re-scan for new buttons after DOM changes
    this.cardBuy.init(this) // <-- re-init to bind fresh nodes

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile'
      sessionStorage.setItem(`product-grid-view-${viewport}`, value)
    })
  }

  #setLayout(value) {
    const { grid } = this.refs
    if (!grid) return
    grid.setAttribute('product-grid-view', value)
  }

  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]')

    if (!(targetElement instanceof HTMLInputElement)) return
    targetElement.checked = true
    this.#setLayout('default')

    // In case the layout swap injected/changed buttons
    this.cardBuy.init(this) // <-- keep CardBuy in sync
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList)
}
